import { AfterViewInit, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { Artikel } from '../../store/models/artikel';
import { ArtikelsService } from '../../artikels/shared/artikels.service';
import { Advertise } from '../../store/models/advertise';
//import { AdvertiseService } from '../shared/advertise.service';
import { ViewEncapsulation } from '@angular/core';
import { EnvironmentService } from '@abp/ng.core';

@Component({
    selector: 'kkis-app-webshop-advertise',
    templateUrl: './advertise.component.html',
    styleUrls: ['./advertise.component.scss'],
    encapsulation: ViewEncapsulation.None //https://stackoverflow.com/questions/46403698/css-values-not-applying-on-dynamically-injected-html-div-elements-in-angular-4
})
export class AdvertiseComponent implements OnInit {

    advertise: Advertise.IAdvertiseDto[];

    responsiveOptions;

    // Utils
    isLoading: boolean = true;

    main_el: ElementRef;
    
    constructor(
        private artikelsService: ArtikelsService, //steckt in Artikelservice drin. ToDo: in AdvertiseService umlagern
        private _renderer2: Renderer2,
        main_el: ElementRef,
        private environment: EnvironmentService //Eric

    ) {
        this.main_el = main_el;
     }

    
    ngOnInit(): void {
        
        this.artikelsService.getListAdvertiseAsync().subscribe(res => {
            
            const environment = this.environment.getEnvironment();
            console.log("setting adv_pagertime: ", environment.setting.adv_pagertime);
            
            $('kkis-app-webshop-advertise').hide();

            if (res) {
                //Sind Werbedatensätze vorhanden? --> ganze Section einblenden
                if (res.length > 0) {
                    $('kkis-app-webshop-advertise').show();
                    $('kkis-app-webshop-advertise').height(window.innerHeight - 64);
                    window.scrollTo(0,0);

                    var bg_width = 1920;
                    var bg_height = 1080;
                    var screenwidth_new = window.innerWidth; //1920
                    var screenheight_new = window.innerHeight - 54; //1080 - 60?

                    var offset_y = screenheight_new - (bg_height / (bg_width / screenwidth_new));
                    offset_y = (offset_y < 0 ? 0 : offset_y); //kein offset < 0
                    
                    const parent = this.main_el.nativeElement.querySelector('#div_advertise');
                    const parent_progress = this.main_el.nativeElement.querySelector('#adv_progress');

                    //Progress Control
                    const adv_progress_ctrl = this._renderer2.createElement('div'); 
                    //this._renderer2.setAttribute(adv_progress_ctrl, 'data-num', i.toString())
                    this._renderer2.setAttribute(adv_progress_ctrl, 'id', 'adv_progress_ctrl');
                    this._renderer2.setAttribute(adv_progress_ctrl, 'data-progressctrl_status', 'running');
                    this._renderer2.appendChild(parent_progress, adv_progress_ctrl);
                    this._renderer2.listen(adv_progress_ctrl, 'click', (event) => this.toggleprogressctrl_state());

                    for(let i=0;i<res.length ;i++){ 
                        
                        //console.log('parentid: '+parent.id);

                        var text;

                        //Background/Item an sich
                        const adv_item = this._renderer2.createElement('div'); 
                        this._renderer2.setAttribute(adv_item, 'data-num', i.toString())
                        this._renderer2.setStyle(adv_item, 'background-image', "url(data:image/jpg;;base64,"+res[i].background+")");
                        this._renderer2.setStyle(adv_item, 'background-position-y', offset_y+"px");
                        this._renderer2.addClass(adv_item, 'adv_item');
                        this._renderer2.appendChild( parent, adv_item);
                                                
                        //this._renderer2.listen(adv_item, 'click', (event) => this.myscript1());

                        //Progress Item
                        const adv_progress_item = this._renderer2.createElement('div'); 
                        this._renderer2.setAttribute(adv_progress_item, 'data-num', i.toString())
                        this._renderer2.addClass(adv_progress_item, 'adv_progress_item');
                        if (i==0) {
                            this._renderer2.addClass(adv_progress_item, 'active');
                        }
                        this._renderer2.appendChild( parent_progress, adv_progress_item);

                        // primär pagerCation  --> sekundär headline
                        //console.log("pagerCaption: "+res[i].pagerCaption);
                        if (res[i].pagerCaption != "" && res[i].pagerCaption != undefined) {
                            text = this._renderer2.createText(res[i].pagerCaption);
                        } else {
                            text = this._renderer2.createText(res[i].headline.replace(/\~/g," "));
                        }
                        
                        this._renderer2.appendChild( adv_progress_item, text);

                        this._renderer2.listen(adv_progress_item, 'click', (event) => this.set_adv_item_active(i.toString()));

                        
                        const adv_item_wrap = this._renderer2.createElement('div'); 
                        this._renderer2.appendChild( adv_item, adv_item_wrap);

                        //close btn 
                        const adv_btnclose = this._renderer2.createElement('div');
                        this._renderer2.addClass(adv_btnclose, 'adv_btn_close');
                        this._renderer2.appendChild(adv_item, adv_btnclose);
                        this._renderer2.listen(adv_btnclose, 'click', (event) => this.hide_advertise());

                        //Headline
                        const adv_headline = this._renderer2.createElement('div');
                        
                        var splitted = res[i].headline.split("~");
                        //console.log(splitted);
                        for(let i2=0;i2<splitted.length ;i2++){ 
                            
                            const adv_headline_text = this._renderer2.createElement('div');

                            text = this._renderer2.createText(splitted[i2]);
                            
                            this._renderer2.appendChild( adv_headline_text, text);
                            this._renderer2.appendChild( adv_headline, adv_headline_text);
                        }

                        //this._renderer2.appendChild( adv_headline, text);
                        this._renderer2.addClass(adv_headline, 'adv_headline');
                        this._renderer2.appendChild( adv_item_wrap, adv_headline);

                        //this._renderer2.listen(adv_headline, 'click', (event) => this.myscript2());

                        //Description
                        const adv_description = this._renderer2.createElement('div');

                        var splitted_descr = res[i].description.split("~");
                        //console.log(splitted_descr);
                        for(let i2=0;i2<splitted_descr.length ;i2++){ 
                            
                            const adv_descr_text = this._renderer2.createElement('div');
                            this._renderer2.addClass(adv_descr_text, 'adv_descr_line');

                            text = this._renderer2.createText(splitted_descr[i2]);
                            
                            this._renderer2.appendChild( adv_descr_text, text);
                            this._renderer2.appendChild( adv_description, adv_descr_text);
                        }


                        //text = this._renderer2.createText(res[i].description);
                        //this._renderer2.appendChild( adv_description, adv_descr_text);
                        this._renderer2.addClass(adv_description, 'adv_description');
                        this._renderer2.appendChild( adv_item_wrap, adv_description);

                        //Button
                        if (res[i].returnLink != "" && res[i].returnLink != undefined) {
                            const adv_button = this._renderer2.createElement('div');
                            this._renderer2.setAttribute(adv_button, 'class', 'adv_button mat-focus-indicator mat-flat-button mat-button-base mat-accent');

                            if (res[i].returnLinkCaption != undefined) {
                                text = this._renderer2.createText(res[i].returnLinkCaption);
                            } else {
                                text = this._renderer2.createText("Weiter");
                            }
                            
                            this._renderer2.appendChild( adv_button, text);
                            this._renderer2.appendChild( adv_item_wrap, adv_button);

                            //console.log("returnlink: "+res[i].returnLink);

                            this._renderer2.listen(adv_button, 'click', (event) => this.openurl(res[i].returnLink));
                        }

                    }

                    this.rotate_adv(environment.setting.adv_pagertime);
                    //this.rotate_adv(30000);

                } else {
                    console.log('Advertise NICHT gefunden');
                }

                //this.advertise = res; //wichtig --> Carousel befüllen

                //this.isLoading = false;
            } else {
                //this.isLoading = false;
            }
        });

    }

    rotate_adv(duration=20000) {
        let start: number = 0;
        let adv_item_c = $('.adv_item').length;

        let theLoop: (i: number) => void = (i: number) => {

            setTimeout(() => {
                
                let progressctrl_status = $('#adv_progress_ctrl').attr('data-progressctrl_status');
                //console.log('progressctrl_status: '+progressctrl_status);

                if (progressctrl_status == 'running') {

                    if (start < adv_item_c - 1) {
                        start++;
                    } else {
                        start = 0; //wieder von vorne anfangen
                    }
               
               
                    this.set_adv_item_active(start.toString());

                }

                if (--i) {
                    theLoop(i);
                }

            }, duration); //Dauer wird als Parameter übergeben
        
        };

        theLoop(1000);
    }
    
    openurl(url:string) {
        if (url.substring(0,1) == "~") {
            //intern
            url = url.replace("~","");
            console.log('navigate to: ' + window.location.origin + "/" + url + "&showAdvertise=false");
            window.open(window.location.origin + "/" +  url + "&showAdvertise=false", '_blank');
        } else {
            //extern
            console.log('navigate to: ' + url);
            window.open(url, '_blank');
        }        
    }

    set_adv_item_active(num:string='0') {
        $('.adv_item').hide();
        $('.adv_item').removeClass('animate');
        $('.adv_item[data-num=' + num + ']').show();
        $('.adv_item[data-num=' + num + ']').addClass('animate');

        $('.adv_headline').removeClass('animate');
        $('.adv_item[data-num=' + num + '].adv_headline').addClass('animate');

        $('.adv_progress_item').removeClass('active');
        $('.adv_progress_item[data-num=' + num + ']').addClass('active');
    }

    toggleprogressctrl_state() {
        if ($('#adv_progress_ctrl').attr('data-progressctrl_status') == 'running') {
            $('#adv_progress_ctrl').attr('data-progressctrl_status','paused');
        } else {
            $('#adv_progress_ctrl').attr('data-progressctrl_status','running');
        }
    }

    hide_advertise() {
        $('kkis-app-webshop-advertise').hide(); 
    }

}
